export const NUMBER_OF_PANORAMAS = {
    crossway: 1,
    sign: 3,
    yesno: 1,
};
